/*
 *	Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */
angular.module('access.Utils')
    .factory('promiseChain', [
        '$q',
        function ($q) {
            /**
             * Call each promise creator function sequentially
             * 
             * @param {Function[]} promiseCreators - List of functions each of them returns a Promise
             * @return {Promise} Promise to be resolved once all function will be called and resolved
             */
            return function promiseChain(promiseCreators) {
                var promise = $q.resolve();

                promiseCreators.forEach(function (promiseCreator) {
                    promise = promise.then(promiseCreator);
                });

                return promise;
            };
        }
    ])
